import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { FacturacionService } from '@facturacion/shared/services/facturacion.service';
import { TipoSolapaRefacturacion } from '@shared/enums/TipoSolapaRefacturacion';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-refacturacion-index',
  templateUrl: './refacturacion-index.component.html',
  styleUrls: ['./refacturacion-index.component.css']
})
export class RefacturacionIndexComponent {

  TipoUsuario = TipoUsuario;
  TipoSolapaRefacturacion = TipoSolapaRefacturacion;
  tituloReporte: string = 'Historial de Refacturación';

  constructor(public authService: AuthService, public facturacionService: FacturacionService) {
    this.tituloReporte = `${this.facturacionService.isSeguimientosRefacturacion ? 'Seguimiento' : 'Historial'} de Refacturación`;
  }
}
